module.exports = __webpack_public_path__ + "img/twitter.5dc442f1.svg";